import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class FileAttachmentService {

  constructor(private readonly http: HttpClient) {
  }

  private get tickeAPI(): string {
    const domain = sessionStorage.getItem('Domain');
    if (domain === 'L') {
      return environment.liveURL;
    } else {
      return environment.ticketAPI;
    }
  }

  donwloadFile(fileName: string): Observable<any> {
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('[FileAttachmentService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const url = `${this.tickeAPI}/secure-attachment/`;
    const formData = new FormData();
    formData.append('file_name', fileName);

    return this.http.post(
      url,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
        }),
      }
    )
  }

  inlineFilesUpload(fileName: string): Observable<any> {
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('[FileAttachmentService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    const url = `${this.tickeAPI}/secure-attachment/`;
    const formData = new FormData();
    formData.append('file_name', fileName);

    return this.http.post(
      url,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`,
        }),
      }
    )
  }
}
